<template>
  <div class="admin-scenes">

    <el-alert
      v-if="!hasRelays"
      title="WARNING: Field has no relays"
      type="warning"
      show-icon
      style="margin-top:10px; font-weight: bold; color: black;">
    </el-alert>

    <div class="panelheader border-4">

      <div class="title">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/admin/clients'}">Clients Admin</el-breadcrumb-item>        
          <el-breadcrumb-item :to="{ path: '/admin/clients/' + clientId}">Sites Admin</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: `/admin/clients/${clientId}/site/${siteId}`}">Fields Admin</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      
      <div class="btn-wrapper">
        <el-button type="add" @click="onNewScene">New Scene</el-button>
      </div>

    </div>

      <div class="scenes">
        <h2> {{ fieldName }} </h2>

        <div v-if="newScene">
          <newscene :fieldId="id" @close="onClose"></newscene>
        </div>
        <div v-else-if="editScene">
          <editscene :fieldId="id" :sceneData="sceneData" @close="onClose"></editscene>
        </div>
        <div v-else>
          <scenetable v-if='!reloading'
            :id="id"
            @editScene="onEditScene" 
            @deleteScene="onDeleteScene">
          </scenetable>
        </div>

      </div>

  </div>
</template>

<script>
  import auth from '../../../auth'
  import requests from '../../../requests';

  import newScene from './NewScene.vue';
  import editScene from './EditScene.vue';
  import sceneTable from './SceneTable.vue';
  
  export default {
    name: 'admin-fields',
    data () {
      return {
        pageName: 'Scenes Admin',
        fieldName: '',
        clientId: 0,
        siteId: 0,
        id: 0,
        sceneData: {
          name: '',
          percentage: 0,
          consumption: 0,
          logical_no:'',
          power_relay:'',
          function_id:''
        },
        newScene: false,
        editScene: false,
        userIsSuperAdmin: false,
        reloading: false,
        hasRelays: false
      }
    },
    beforeMount(){
      var profile = JSON.parse(auth.getProfile());
      this.userIsSuperAdmin = (profile.role === 3);
      
      this.newScene = false;
      this.editScene = false;

      this.clientId = this.$route.params.clientId;
      this.siteId = this.$route.params.siteId;
      this.id = this.$route.params.id;

      var context = this;
      requests.getField(this, context.id, function (result) {
        context.fieldName = result.data.field_name;
      });

      requests.getFieldsRelays(this, context.id, function(result) {
        if(result.data.length !== 0) {
          context.hasRelays = true;
        }
      });

    },
    updated() {
      this.reloading = false;
    },
    methods: {
      onNewScene() {
        this.editScene = false;
        this.newScene = true;
      },
      onEditScene(sceneData) {
        this.sceneData = sceneData;

        this.newScene = false;
        this.editScene = true;
      },
      onDeleteScene(id) {
        var context = this;
        requests.deleteScene(this, id, function(result) {
          if(result.action !== 'success') {
            console.log(result);
            context.$message({
              showClose: true,
              type: 'error',
              message: 'Couldn\'t delete scene: ' + result.msg.body.msg,
            });
          } else {
            context.$message({
              showClose: true,
              type: 'success',
              message: 'Successfully deleted scene',
            });
          }
          context.reloading = true;
        });
      },
      onClose() {
        this.newScene = false;
        this.editScene = false;
      },
    },
    components: {
      'newscene': newScene,
      'editscene': editScene,
      'scenetable': sceneTable
    }
  }
</script>

<style>

  .scenes {
    display: block;
    padding: 15pt;
    background-color: white;
  }

  .fieldtable .el-table__row {
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// Scenes.vue?ace457c4